import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-ai",
  "use": "icon-sidebar-ai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sidebar-ai\"><path d=\"M976.76 157.28l-288 744a48 48 0 0 1-78 17.4L448.46 763.4l-99.6 99.54a24 24 0 0 1-40.92-17.04V629L58.76 390.68A48 48 0 0 1 80 309.5l840-216a48 48 0 0 1 56.76 63.78zM859.94 212L333.5 555.26l83.28 79.68L859.94 212z\" p-id=\"11009\" fill=\"#02b28e\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol